import { campaignCouponService } from "@/api/campaignCouponService";
import { packageCouponService } from "@/api/packageCouponService";
import type { CampaignCoupon, Coupon } from "@/resources/coupon";

async function executeCouponEdit(
  operation: () => Promise<boolean>,
  entityType: string,
  id: string,
  couponCode: string,
): Promise<void> {
  try {
    const result = await operation();
    if (!result) {
      throw new Error(
        `Failed to edit coupon ${couponCode} in ${entityType} ${id}`,
      );
    }
  } catch (error) {
    console.error(
      `Failed to edit coupon ${couponCode} in ${entityType} ${id}:`,
      error,
    );
    throw error;
  }
}

export async function editCoupon(
  collectionName: "packages" | "campaigns",
  id: string,
  couponCode: string,
  newCouponData: Partial<CampaignCoupon>,
): Promise<void> {
  if (!collectionName || !id || !couponCode || !newCouponData) {
    throw new Error(
      "Invalid parameters: collection, id, couponCode and newCouponData are required",
    );
  }

  if (collectionName !== "packages" && collectionName !== "campaigns") {
    throw new Error(
      'Invalid collection name. Must be "packages" or "campaigns".',
    );
  }

  if (collectionName === "campaigns") {
    await executeCouponEdit(
      () =>
        campaignCouponService.updateByCampaignIdAndCouponCode(
          id,
          couponCode,
          newCouponData,
        ),
      "campaign",
      id,
      couponCode,
    );
  } else if (collectionName === "packages") {
    await executeCouponEdit(
      () =>
        packageCouponService.updateByPackageIdAndCouponCode(
          id,
          couponCode,
          newCouponData as Partial<Coupon>,
        ),
      "package",
      id,
      couponCode,
    );
  }
}
